import React from 'react';
import MedicationReferenceScreen from '../../screens/MedicationReferenceScreen';
import { hospitalHex } from '../shared/HospitalHeader';

/*
 * Tools the Texas Children's rotations can open, by action id (see data/hospitals/tchOr.js).
 * `calculator` opens the shared Medication Reference locked to the pediatric category,
 * so the weight-based doses on the rotation page and under Clinical Tools are one thing.
 */
const tchTools = {
  calculator: {
    render: (ctx) => (
      <MedicationReferenceScreen initialCategory="pediatric" lockCategory backLabel="Back" accent={hospitalHex(ctx.hospital)} onBack={ctx.close} />
    ),
  },
};

export default tchTools;
